import { memo } from 'react';
import { Switch, SwitchProps } from '@mui/material';

type Props = Omit<SwitchProps, 'checked' | 'sx'> & {
  /** null means the selected items have different values ('Mixed') */
  checked: boolean | null;
};

// MUI's Switch has no third state, so 'Mixed' parks the thumb halfway and dims it.
// Clicking it then switches everything on, like checking an indeterminate checkbox.
const MIXED_SX = {
  '& .MuiSwitch-switchBase': { transform: 'translateX(10px)' },
  '& .MuiSwitch-thumb': { opacity: 0.6 },
};

function MixedSwitchComponent({ checked, ...props }: Props) {
  const isMixed = checked === null;

  return <Switch {...props} checked={checked ?? false} sx={isMixed ? MIXED_SX : undefined} />;
}

export const MixedSwitch = memo(MixedSwitchComponent);
